import PropTypes from 'prop-types';
import React, { Component } from "react";
import Relay from "react-relay"
import Masonry from "react-masonry-component"
import ArticleResult from "./ArticleResult"
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'

class SetResources extends Component {
  render() {
    const {
      userSet: {
        resources
      },
      articleStyle
    } = this.props

    const results =
      resources.edges.map(({ node }) => (
        <ArticleResult view="favourites" key={node.id} resource={node} />
      )) || []

    return (
      <section
        className="search-results__listings"
        style={getStyles('search-results__listings')}
        data-article-style={articleStyle}
      >
        {getStyleTag(['search-results__listings'])}
        {results.length === 0 && <p>This set is empty.</p>}
        {results.length > 0 && (
          <div>
            {articleStyle === "fluid" ? (
              <Masonry key="masonry" percentPosition elementType="div">
                {results}
              </Masonry>
            ) : (
              results
            )}
          </div>
        )}
      </section>
    )
  }
}

SetResources.propTypes = {
  userSet: PropTypes.object.isRequired,
  articleStyle: PropTypes.string.isRequired
}

export default Relay.createContainer(SetResources, {
  fragments: {
    userSet: () => Relay.QL`
      fragment on UserSet {
        name
        resources(first: 200){
           total
           edges {
             node {
             id
             ${ArticleResult.getFragment("resource")}
             }
           }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/SetResources.js